import { getLabDrawsByOrderOptions } from '@generated';
import { useOrderItems } from '~/features/orders/queries';

export function useGetLabOrders(orderId: string) {
	return useOrderItems(orderId, getLabDrawsByOrderOptions, (fullOrder, result) => {
		fullOrder.labs = result;
	});
}
